import { Link } from 'react-router-dom'
import { CompassIcon } from 'lucide-react'
import { PageLayout } from '../components/PageLayout'

export function NotFoundPage() {
  return (
    <PageLayout title="Page not found">
      <div className="rounded-2xl border border-dashed border-slate-300 bg-white p-10 text-center dark:border-slate-600 dark:bg-slate-800">
        <CompassIcon className="mx-auto mb-3 h-10 w-10 text-slate-400" aria-hidden="true" />
        <p className="text-sm text-slate-500">
          We couldn't find that page.{' '}
          <Link to="/home" className="text-butler-600 underline">
            Back to Home
          </Link>
        </p>
      </div>
    </PageLayout>
  )
}
